/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Grid,
} from '@material-ui/core';

export default function Create({
  openCreate,
  setOpenCreate,
  loadingCreate,
  handleCreate,
  name,
  setName,
  handleClean,
}) {
  return (
    <Dialog open={openCreate} onClose={handleClean} fullWidth maxWidth="sm">
      <DialogTitle>Nova Categoria</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Nome"
              variant="outlined"
              fullWidth
              value={name}
              onChange={e => setName(e.target.value)}
              inputProps={{ maxLength: 255 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button onClick={handleClean} disabled={loadingCreate}>
          Cancelar
        </Button>
        <Button
          onClick={handleCreate}
          variant="contained"
          color="primary"
          disabled={loadingCreate}
        >
          {loadingCreate ? <CircularProgress size={22} /> : 'Criar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}